/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["loading-toast{display:flex;align-items:center}loading-toast .mat-spinner{margin-right:20px}loading-toast .mat-spinner circle{stroke:#fff}"];
export { styles as styles };
